import { render, staticRenderFns } from "./ApplyingSettings.vue?vue&type=template&id=32d2b9ba&scoped=true&"
import script from "./ApplyingSettings.vue?vue&type=script&lang=js&"
export * from "./ApplyingSettings.vue?vue&type=script&lang=js&"
import style0 from "./ApplyingSettings.vue?vue&type=style&index=0&id=32d2b9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2b9ba",
  null
  
)

export default component.exports